import styled from 'styled-components';

import { ToolTip } from 'src/app/components/Elements/ToolTip';

export const ToolTipContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledToolTip = styled(props => <ToolTip {...props} />)``;
